import type { Config } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

const useConfig = () => {
  const { data } = useQuery<GetConfig>(`config`, () =>
    getJSON({ url: '/api/config' })
  )

  return {
    config: data?.result
  }
}

export type GetConfig = {
  result?: Config
}

export default useConfig
